// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3G10X","field":"styles_field__7I9U4","fieldCol":"styles_fieldCol__3eTd-","diffCol":"styles_diffCol__15e_5","diff":"styles_diff__3JaFZ"};